// react
import PropTypes from "prop-types";
import React, { useRef } from "react";

import { useInputFlash } from "@performyard/py-components";
// components
import { InputWrapper, TitleLabel } from "@performyard/py-components";

import { createInputId } from "../../../hooks/useInputId";

// style
import css from "./LongText.module.scss";

const LongText = ({
	disabled = false,
	onChange = () => {},
	onKeyDown = () => {},
	onBlur = () => {},
	onFocus = () => {},
	onKeyUp = () => {},
	placeholder = "",
	name = "",
	className = "",
	style = {},
	value = "",
	label = "",
	testId,
	titleHref,
	titleImage,
	inputTooltip,
	inputId = createInputId(),
	flashKey,
	labelRight,
	labelSize,
	labelWeight,
}) => {
	const inputRef = useRef(null);
	const { flashing, onAnimationEnd } = useInputFlash(flashKey);

	const focus = () => {
		inputRef.current?.focus();
	};

	const handleChange = (e) => {
		onChange(e.target.value);
	};

	const handleFocus = () => {
		onFocus();
	};

	const handleBlur = () => {
		onBlur();
	};

	const handleKeyDown = (e) => {
		onKeyDown(e.key);
	};

	const handleKeyUp = (e) => {
		onKeyUp(e.key);
	};

	return (
		<InputWrapper
			label={
				label && (titleHref || titleImage) ? (
					<TitleLabel
						label={label}
						titleHref={titleHref}
						titleTooltip={inputTooltip}
						titleImage={titleImage}
					/>
				) : (
					label
				)
			}
			labelRight={labelRight}
			labelSize={labelSize}
			labelWeight={labelWeight}
			id={inputId}
		>
			<textarea
				ref={inputRef}
				id={inputId}
				className={`react-input ${className} ${css.textareaInput} ${flashing ? "animate-input-flash" : ""}`}
				value={value}
				name={name}
				disabled={disabled}
				onBlur={handleBlur}
				onFocus={handleFocus}
				onChange={handleChange}
				onAnimationEnd={onAnimationEnd}
				placeholder={placeholder}
				onKeyUp={handleKeyUp}
				onKeyDown={handleKeyDown}
				style={{ borderBox: "box-sizing", width: "100%", ...style }}
				data-testid={testId}
			/>
		</InputWrapper>
	);
};

LongText.propTypes = {
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	onKeyDown: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onKeyUp: PropTypes.func,
	placeholder: PropTypes.string,
	name: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.object,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	label: PropTypes.string,
	testId: PropTypes.string,
	titleHref: PropTypes.string,
	titleImage: PropTypes.string,
	inputTooltip: PropTypes.string,
	flashKey: PropTypes.number,
	labelRight: PropTypes.node,
	labelSize: PropTypes.string,
	labelWeight: PropTypes.string,
};

export default LongText;
